import { Category, Subcategory } from '../entities/category'
import { Product } from '../entities/product'

export const setCookie = (cName, value, validityDays) => {
  const today = new Date()
  const validityMiliSeconds = validityDays * 24 * 60 * 60 * 1000
  const expirationDate = new Date(
    today.getTime() + validityMiliSeconds
  ).toUTCString()

  document.cookie = `${cName}=${value};expires=${expirationDate}`
}

export const getCookie = (cookieName) => {
  const allCookies = document.cookie.split(';')
  let searchedCookie
  allCookies.forEach((cookie) => {
    if (cookie.includes(cookieName)) searchedCookie = cookie
  })
  const indexOfValue = searchedCookie?.indexOf('=') + 1
  const value = searchedCookie?.substring(indexOfValue)

  return value
}

export const deleteCookie = (cookieName) => {
  document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:01 GMT`
}
// Formatear números a pesos argentinos
export const formatter = (decimalDigits = 2) => {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: decimalDigits
  })
}
// generar instancias de Categories
export const normalizedCategories = (categoriesArray) => {
  return categoriesArray.map((category) => {
    const normalizedCategory = new Category(
      category.idCategory,
      category.name,
      category.bannerURL,
      category.imageURL,
      category.routeURL
    )
    normalizedCategory.subcategories = category.subCategories.map(
      (subCategory) => {
        return new Subcategory(
          subCategory.idCategory,
          subCategory.name,
          subCategory.imageURL,
          subCategory.routeURL
        )
      }
    )

    return normalizedCategory
  })
}

export const normalizeProduct = (product) => {
  const isPromotion =
    Boolean(product.voidedPrice) || Boolean(product.priceIncreasePercentage)

  const markedPrice = product.voidedPrice
    ? product.voidedPrice
    : (1 + product.priceIncreasePercentage / 100) * product.price

  const normalizedProduct = new Product(
    product.idProduct,
    product.sku,
    product.name,
    product.img,
    product.description,
    product.price,
    product.volumePrices,
    markedPrice,
    isPromotion,
    product.dolarValue,
    product.category,
    product.categoryName
  )

  normalizedProduct.components = product.components
  normalizedProduct.webRelatedProducts = product.webRelatedProducts

  return normalizedProduct
}
// generar instancias de Product
export const normalizeProducts = (productsArray) => {
  return productsArray.map((product) => {
    return normalizeProduct(product)
  })
}
// Obtener array de objetos por color, con talle y cantidad
export const getSizesByColor = (product) => {
  const sizesByColor = []

  product?.components?.forEach((component) => {
    if (
      !sizesByColor.find(
        (element) => element.descriptionColor === component.descriptionColor
      )
    ) {
      sizesByColor.push({
        descriptionColor: component.descriptionColor,
        colorHexa: component.colorHexa,
        img: product.img,
        imgC: component.imgComponent,
        types: [
          {
            idComponent: component.idComponent,
            idProduct: product.idProduct,
            size: component.descriptionSize,
            stock: component.stock,
            quantity: component.quantity
          }
        ]
      })
    } else {
      const index = sizesByColor.findIndex(
        (element) => element.descriptionColor === component.descriptionColor
      )
      const newType = [
        ...sizesByColor[index].types,
        {
          idComponent: component.idComponent,
          idProduct: product.idProduct,
          size: component.descriptionSize,
          stock: component.stock,
          quantity: component.quantity
        }
      ]

      sizesByColor[index].types = newType
    }
  })
  return sizesByColor
}
// Obtener cantidad de articulos de un tipo en particular
export const getQuantityByProduct = (products) => {
  return products.reduce(
    (acc, product) =>
      acc +
      product.types.reduce((acc, type) => {
        return acc + type.quantity
      }, 0),
    0
  )
}
// Obtener colores de un producto
export const getColors = (product) => {
  const colors = []
  product.components?.forEach((component) => {
    if (!colors.find((element) => element.color === component.color)) {
      colors.push({ color: component.color, img: component.img })
    }
  })
  return colors
}
// Obtiene el producto en cart que coincida con el del ItemDetailContainer
export const productInCart = (cart, id) => {
  cart?.find((element) => element.idProduct === parseInt(id))
}
// Obtiene todos los idComponents con sus quantities
export const getComponentsWithQuantity = (components) => {
  const componentsWithQuantity = []

  components?.forEach((component) =>
    componentsWithQuantity.push({
      idComponent: component.idComponent,
      quantity: component.quantity
    })
  )
  return componentsWithQuantity
}

export const getCarrierId = (carriers, carrier) => {
  return (
    carriers.find(
      (carrierList) => carrierList.name.toLowerCase() === carrier.toLowerCase()
    )?.id || 0
  )
}

export const getCarrierName = (carriers, id) => {
  return carriers.find((carrier) => carrier.id === id)?.name || carriers[0].name
}

export const getOrderTotalAmount = (products) => {
  const amount = products.reduce((acc, product) => {
    return acc + product.price * product.quantity * product.dolarValue
  }, 0)

  return amount
}

export const getOrderDate = (date) => {
  return date.getDate()
}

export const getMonth = (date) => {
  return date.getMonth()
}

export const getPrice = (volumePrices, price, quantity) => {
  if (!volumePrices || volumePrices.length === 0) {
    return price
  }

  const sortedPrices = [...volumePrices].sort(
    (a, b) => a.minQuantity - b.minQuantity
  )

  for (let i = sortedPrices.length - 1; i >= 0; i--) {
    if (quantity >= sortedPrices[i].minQuantity) {
      return sortedPrices[i].price
    }
  }

  return price
}

export const getQuantity = (product) => {
  return product.components.reduce(
    (sum, component) => sum + component.quantity,
    0
  )
}
